module.exports = __webpack_public_path__ + "img/16.cbc45f07.png";